import {Component, Input, TemplateRef, Output, EventEmitter} from '@angular/core';
import {MonthViewModel, DayViewModel, WeekViewModel} from './datepicker-view-model';
import {FishDate} from './fish-date';
import {FishDatepickerI18n} from './datepicker-i18n';
import {DayTemplateContext} from './datepicker-day-template-context';


export class FishDatepickerMonthView {
   dayTemplate: TemplateRef<DayTemplateContext>;
   disabled: boolean;
   month: MonthViewModel;
   outsideDays: 'visible' | 'hidden' | 'collapsed';
   selectedDate: FishDate;
   showWeekdays;
   showWeekNumbers;

   select = new EventEmitter<FishDate>();

  constructor(public i18n: FishDatepickerI18n) {}

  doSelect(day: DayViewModel) {
    if (!this.isDisabled(day) && !this.isHidden(day)) {
      this.select.emit(FishDate.from(day.date));
    }
  }

  _getDayContext(day: any, month: any) {
    return {
      date: {year: day.date.year, month: day.date.month, day: day.date.day},
      currentMonth: month.number,
      disabled: this.isDisabled(day),
      selected: this.isSelected(day.date)
    };
  }

  isDisabled(day: DayViewModel) { return this.disabled || day.disabled; }

  isSelected(date: FishDate) { return this.selectedDate && this.selectedDate.equals(date); }

  isCollapsed(week: WeekViewModel) {
    return this.outsideDays === 'collapsed' && week.days[0].date.month !== this.month.number &&
        week.days[week.days.length - 1].date.month !== this.month.number;
  }

  isHidden(day: DayViewModel) {
    return (this.outsideDays === 'hidden' || this.outsideDays === 'collapsed') && this.month.number !== day.date.month;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'fish-datepicker-month-view',
  host: {'class': 'd-block'},
  styles: [`
    .fish-dp-weekday, .fish-dp-week-number {
      line-height: 2rem;
    }
    .fish-dp-day, .fish-dp-weekday, .fish-dp-week-number {
      width: 2rem;
      height: 2rem;      
    }
    .fish-dp-day {
      cursor: pointer;
    }
    .fish-dp-day.disabled, .fish-dp-day.hidden {
      cursor: default;
    }
  `],
  template: `
    <div *ngIf="showWeekdays" class="fish-dp-week d-flex">
      <div *ngIf="showWeekNumbers" class="fish-dp-weekday"></div>
      <div *ngFor="let w of month.weekdays" class="fish-dp-weekday small text-center text-info font-italic">
        {{ i18n.getWeekdayShortName(w) }}
      </div>
    </div>
    <ng-template ngFor let-week [ngForOf]="month.weeks">
      <div *ngIf="!isCollapsed(week)" class="fish-dp-week d-flex">
        <div *ngIf="showWeekNumbers" class="fish-dp-week-number small text-center font-italic text-muted">{{ week.number }}</div>
        <div *ngFor="let day of week.days" (click)="doSelect(day)" class="fish-dp-day" [class.disabled]="isDisabled(day)"
         [class.hidden]="isHidden(day)">
          <ng-template [ngIf]="!isHidden(day)">
            <ng-template [ngTemplateOutlet]="dayTemplate"
            [ngOutletContext]="_getDayContext(day, month)">
            </ng-template>
          </ng-template>
        </div>
      </div>
    </ng-template>
  `
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: FishDatepickerI18n, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'dayTemplate': [{ type: Input },],
'disabled': [{ type: Input },],
'month': [{ type: Input },],
'outsideDays': [{ type: Input },],
'selectedDate': [{ type: Input },],
'showWeekdays': [{ type: Input },],
'showWeekNumbers': [{ type: Input },],
'select': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
